module.exports = __webpack_public_path__ + "assets/001-sheets.3bf0d5bc.svg";